export default __webpack_public_path__ + "static/media/tmgsl_xcelion-logo-rgb-Edited_updated.8091872c.png";